(function () {
    const second = 1000,
            minute = second * 60,
            hour = minute * 60,
            day = hour * 24;

    const startDate = "05/15/2023 12:00:00";
    const endDate = "05/26/2023";

    const preCountDown = new Date(startDate).getTime(),
        x = setInterval(function() {    
            const now = new Date().getTime(),
                distance = preCountDown - now;

            const d = document;
            const daysElement = d.querySelector('#pre-countdown .days');
            const hoursElement = d.querySelector('#pre-countdown .hours');
            const minutesElement = d.querySelector('#pre-countdown .minutes');
            const secondsElement = d.querySelector('#pre-countdown .seconds');

            if(daysElement) {
                daysElement.textContent = Math.floor(distance / (day)),
                hoursElement.textContent = Math.floor((distance % (day)) / (hour)),
                minutesElement.textContent = Math.floor((distance % (hour)) / (minute)),
                secondsElement.textContent = Math.floor((distance % (minute)) / second);
            }

            //do something later when date is reached
            if (distance < 0) {
                if(document.getElementById("#pre-countdown")) {
                    document.getElementById("#pre-countdown").style.display = "none";
                }
                clearInterval(x);
            }
            //seconds
        }, 0)

    const countDown = new Date(endDate).getTime(),
        y = setInterval(function() {    
            const now = new Date().getTime(),
                distance = countDown - now;

            const d = document;
            const daysElement = d.querySelector('#countdown .days');
            const hoursElement = d.querySelector('#countdown .hours');
            const minutesElement = d.querySelector('#countdown .minutes');
            const secondsElement = d.querySelector('#countdown .seconds');

            if(daysElement) {
                daysElement.textContent = Math.floor(distance / (day)),
                hoursElement.textContent = Math.floor((distance % (day)) / (hour)),
                minutesElement.textContent = Math.floor((distance % (hour)) / (minute)),
                secondsElement.textContent = Math.floor((distance % (minute)) / second);
            }

            //do something later when date is reached
            if (distance < 0) {
                if(document.getElementById("#countdown")) {
                    document.getElementById("#countdown").style.display = "none";
                }
                clearInterval(y);
            }
            //seconds
        }, 0)
}());